export const TOO_MANY_ATTEMPTS = 429;

export function toLockoutMessage(retryAfterSeconds?: number): {
  message: string;
  params?: { time: number };
} {
  if (!retryAfterSeconds) return { message: "Locked Later" };
  if (retryAfterSeconds >= 3600) {
    return {
      message: "Locked Hours",
      params: { time: Math.ceil(retryAfterSeconds / 3600) },
    };
  }
  return {
    message: "Locked Minutes",
    params: { time: Math.ceil(retryAfterSeconds / 60) },
  };
}
